import { apiClient } from '../utils/api-client'

export interface ConnectedAiClient {
  id: string
  applicationName: string | null
  scopes: string[]
  connectedAt: string | null
  lastAuthorizedAt: string | null
}

interface AuthorizationAttributes {
  application_name: string | null
  scopes: string[]
  connected_at: string | null
  last_authorized_at: string | null
}

interface AuthorizationsResponse {
  data: Array<{
    id: string
    type: string
    attributes: AuthorizationAttributes
  }>
}

class AiIntegrationService {
  /** Absolute URL the user pastes into their AI client as the MCP connector. */
  connectorUrl(): string {
    const base = apiClient.getBaseURL() || window.location.origin
    return `${base.replace(/\/$/, '')}/mcp`
  }

  async listConnections(): Promise<ConnectedAiClient[]> {
    const response = await apiClient.get('/api/oauth_authorizations', { requireAuth: true })
    const json: AuthorizationsResponse = await response.json()
    return json.data.map((d) => ({
      id: d.id,
      applicationName: d.attributes.application_name,
      scopes: d.attributes.scopes,
      connectedAt: d.attributes.connected_at,
      lastAuthorizedAt: d.attributes.last_authorized_at,
    }))
  }

  async revokeConnection(id: string): Promise<void> {
    await apiClient.delete(`/api/oauth_authorizations/${id}`, { requireAuth: true })
  }
}

export const aiIntegrationService = new AiIntegrationService()
